const lineItemBulkView = () => {
    const classes = {
        bulkViewLineItemWaiting: 'line-item--bulk-view-product-waiting',
    };
    const selectors = {
        bulkViewLineItem: '[data-line-item-bulk-view]',
        bulkViewLineItemVariantInput: '[data-line-item-bulk-view-variant-input]',
        bulkViewLineItemVariantID: 'data-variant-id',
    };
    const handleBulkViewLineItemUpdates = () => {
        const bulkViewLineItems = document.querySelectorAll(selectors.bulkViewLineItem);
        bulkViewLineItems.forEach((item) => {
            const variantInputs = item.querySelectorAll(selectors.bulkViewLineItemVariantInput);
            variantInputs.forEach((variantInput) => {
                if (variantInput.dataset.bulkBound === 'true')
                    return;
                variantInput.dataset.bulkBound = 'true';
                variantInput.addEventListener('change', () => {
                    bulkViewLineItems.forEach((line) => {
                        line.classList.add(classes.bulkViewLineItemWaiting);
                    });
                    const updates = {};
                    bulkViewLineItems.forEach((lineItem) => {
                        const inputs = lineItem.querySelectorAll(selectors.bulkViewLineItemVariantInput);
                        inputs.forEach((input) => {
                            const variantID = input.getAttribute(selectors.bulkViewLineItemVariantID);
                            let quantity = parseInt(input.value, 10);
                            if (Number.isNaN(quantity) || quantity < 0)
                                quantity = 0;
                            if (variantID) {
                                updates[variantID] = quantity;
                            }
                        });
                    });
                    if (Object.keys(updates).length > 0) {
                        fetch(window.Shopify.routes.root + 'cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ updates }),
                        })
                            .then((response) => {
                            return response.json();
                        })
                            .then((data) => {
                            document.dispatchEvent(new CustomEvent('cart:refresh'));
                        })
                            .catch((error) => {
                            console.error('Error:', error);
                        });
                    }
                });
            });
        });
    };
    handleBulkViewLineItemUpdates();
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    setTimeout(() => {
                        handleBulkViewLineItemUpdates();
                    }, 400);
                }
            }
        });
        observer.observe(cartDrawer, {
            childList: true,
            subtree: true,
        });
    }
};
export { lineItemBulkView };
